<div class="cdt-container cdt-configuration box-form-ui container">
  <app-cdt-form [preLoad]="true" class="box-cdt-form"></app-cdt-form>
</div>
